import React from 'react'

type ViewType = 'grid' | 'list'

interface FileExplorerLoadingStateProps {
  viewMode: ViewType
}

const FileExplorerLoadingState: React.FC<FileExplorerLoadingStateProps> = ({ viewMode }) => {
  return (
    <div className="flex flex-col gap-4 p-4 text-gray-900 dark:text-white">
      <div className="animate-pulse">
        <div className="h-6 bg-gray-200 dark:bg-gray-700 rounded w-1/3 mb-4" />
        <div className="h-8 bg-gray-200 dark:bg-gray-700 rounded w-1/4 mb-4" />
        {viewMode === 'grid' ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
            {[...Array(8)].map((_, i) => (
              <div key={i} className="h-32 bg-gray-200 dark:bg-gray-700 rounded" />
            ))}
          </div>
        ) : (
          <div className="flex flex-col gap-3">
            {/* List view skeleton */}
            <div className="flex items-center gap-4 p-3 border-b border-gray-200 dark:border-gray-700">
              <div className="w-10 h-10 bg-gray-200 dark:bg-gray-700 rounded" />
              <div className="flex-1">
                <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-1/3 mb-2" />
                <div className="h-3 bg-gray-200 dark:bg-gray-700 rounded w-1/4" />
              </div>
              <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-16" />
              <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-20" />
            </div>
            {[...Array(7)].map((_, i) => (
              <div
                key={i}
                className="flex items-center gap-4 p-3 border-b border-gray-200 dark:border-gray-700"
              >
                <div className="w-10 h-10 bg-gray-200 dark:bg-gray-700 rounded" />
                <div className="flex-1">
                  <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-1/3 mb-2" />
                  <div className="h-3 bg-gray-200 dark:bg-gray-700 rounded w-1/4" />
                </div>
                <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-16" />
                <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-20" />
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}

export default FileExplorerLoadingState
